import { getErrorCodes } from "@artists/devkit"
import { CustomErrorResponses, Roles } from "@artists/gql/design-challenges"
import { useRef } from "react"

import { useAuth } from "../../api"
import { useChallengeQuery } from "../../api/hooks/vote"
import { Page } from "../../components/@shared/page"
import { Content, Header } from "../../components/vote"
import { useNoChallenge, useNoVoting } from "../../utils"
import NotFoundPage from "../not-found"

export default () => {
	const { user, isDataReceived } = useAuth()
	const { data, error } = useChallengeQuery()

	const titleRef = useRef<HTMLDivElement>(null)

	const challenge = data?.challenge
	const errorCodes = error ? getErrorCodes(error) : []

	const noVotingTexts = useNoVoting(challenge)
	const noChallengeTexts = useNoChallenge(
		errorCodes.includes(CustomErrorResponses.NotFound),
	)

	if (noChallengeTexts) return <NotFoundPage {...noChallengeTexts} />

	if (noVotingTexts && user?.role !== Roles.Admin) {
		return <NotFoundPage {...noVotingTexts} />
	}

	return (
		<Page
			title='Votes Page'
			image={challenge?.images.hero1080x560.url.jpeg}
		>
			<Header titleRef={titleRef} challenge={challenge} />
			{isDataReceived && (
				<Content titleRef={titleRef} challenge={challenge} />
			)}
		</Page>
	)
}
